// Card search request (search_cards). The endpoint's Need is OPTIONAL. A
// group search checks the Viewer's membership, so it waits for auth to carry
// the token; a public search (the caller's own binder keys) never reads the
// Viewer, so it sends no token and never waits on auth.

import { API_ENDPOINTS } from './endpoints.js';
import { apiFetch, apiResult } from './api-fetch.js';

/**
 * @param {{ groupId?: string } & Record<string, unknown>} body the search_cards request body
 * @returns {Promise<any>} the parsed response
 */
export async function searchCards(body) {
  const response = await apiFetch(
    API_ENDPOINTS.search_cards,
    { method: 'POST', json: body },
    body.groupId ? {} : { token: null }
  );
  return response.json();
}

/**
 * Card names for the want page's Add a card row (GET search_cards?suggest=):
 * names containing the text, most-played first, or, only when none does, the
 * closest spellings (`closest: true`). Catalog names with nothing
 * Viewer-specific, so no token. A failed request suggests nothing.
 * @param {string} text
 * @returns {Promise<{ names: string[], closest: boolean }>}
 */
export async function suggestCardNames(text) {
  /** @type {import('../types.js').ApiResult<{ names: string[], closest: boolean }>} */
  const res = await apiResult(
    `${API_ENDPOINTS.search_cards}?suggest=${encodeURIComponent(text)}`,
    { method: 'GET' },
    { token: null }
  );
  if (!res.ok || !res.data) return { names: [], closest: false };
  return { names: res.data.names ?? [], closest: !!res.data.closest };
}
